import { Box, SxProps, Theme } from '@mui/material'
import React from 'react'

export interface CustomizableLogoProps {
  /** Color of the logo paths (hex, rgb, or CSS color name) */
  color?: string
  /** Opacity of the logo (0.0 to 1.0) */
  opacity?: number
  /** Width of the logo in pixels or CSS units */
  width?: number | string
  /** Height of the logo in pixels or CSS units */
  height?: number | string
  /** Background color */
  backgroundColor?: string
  /** Border radius */
  borderRadius?: number | string
  /** Padding around the logo */
  padding?: number | string
  /** Rotation angle in degrees */
  rotation?: number
  /** Additional MUI sx props for the container */
  sx?: SxProps<Theme>
  /** CSS class name */
  className?: string
  /** Preserve aspect ratio (default: true) */
  preserveAspectRatio?: boolean
}

const CustomizableLogo: React.FC<CustomizableLogoProps> = ({
  color = '#9AC765',
  opacity = 0.3,
  width = 'auto',
  height = 'auto',
  backgroundColor,
  borderRadius,
  padding,
  rotation = 0,
  sx = {},
  className,
  preserveAspectRatio = true
}) => {
  const viewBox = '0 0 194 407'

  return (
    <Box
      className={className}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor,
        borderRadius,
        padding,
        ...sx
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={{
          transform: rotation !== 0 ? `rotate(${rotation}deg)` : undefined,
          transition: 'transform 0.3s ease'
        }}
        preserveAspectRatio={preserveAspectRatio ? 'xMidYMid meet' : 'none'}
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M193.91 193.91V80.3237L113.592 0L69.8707 43.716L172.792 146.637L129.685 189.739L26.7694 86.823L0.000213623 113.592L80.3239 193.91H193.91Z'
          fill={color}
          fillOpacity={opacity}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M113.592 406.406L193.91 326.083L193.91 212.496H80.3238L0.000213623 292.82L43.7161 336.536L146.637 233.614L189.744 276.721L86.823 379.637L113.592 406.406Z'
          fill={color}
          fillOpacity={opacity}
        />
      </svg>
    </Box>
  )
}

export default CustomizableLogo
